export function copieAdresse(target, value) {
  target.libelle = value.libelle || null;
  target.ligne1 = value.ligne1 || null;
  target.ligne2 = value.ligne2 || null;
  target.ligne3 = value.ligne3 || null;
  target.cedex = value.cedex || null;
  target.codePostal = value.codePostal || null;
  target.ville = value.ville || null;
  target.localite = value.localite || null;
  target.departement = value.departement || null;
  target.pays = value.pays || null;
  return target;
}
